import { render } from "./Service.vue?vue&type=template&id=f57bceb0&scoped=true"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"

import "./Service.vue?vue&type=style&index=0&id=f57bceb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f57bceb0"]])

export default __exports__